module.exports = __webpack_public_path__ + "img/Group@3x 1.95d3cd41.png";